<template>
  <div :class="['userButton', {collapse}]">
    <div class="userButton-avatar"></div>
    <span
      class="userButton-user"
      v-if="!collapse"
    >{{user.fullName}}</span>
  </div>
</template>

<script lang="javascript">
import { mapGetters } from 'vuex';

export default {
  name: 'UserButton',
  props: {
    collapse: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('user', ['user']),
  },
  methods: {
    initUserButton() {
      const avatarEl = this.$el.querySelector('.userButton-avatar');
      this.$auth.mountUserButton(avatarEl);
    },
    openUserMenu() {
      this.$auth.openUserMenu();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initUserButton();
    });
  },
};
</script>

<style lang="scss">
.userButton {
  display: inline-flex;
  align-items: center;
  overflow: hidden;

  .userButton-avatar {
    width: 24px;
    height: 24px;
  }

  .userButton-user {
    margin-left: 16px;
    font-size: 14px;
    color: #2b2b2b;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100px;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
  }

  .cl-avatarBox {
    width: 24px;
    height: 24px;
  }

  &.collapse {
    margin: auto;
  }
}
</style>
